import React, { useContext } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginForm from './pages/login/LoginPage';
import Home from './pages/home/home';
import AuthContext from './context/Auth/AuthContext';

const App = () => {
    const { user, login } = useContext(AuthContext);

    return (
        <Router>
            <Routes>
                <Route path="/login" element={user ? <Navigate to="/home" /> : <LoginForm onLogin={login} />} />
                <Route path="/home/*" element={user ? <Home /> : <Navigate to="/login" />} />
                <Route path="/" element={<Navigate to="/login" />} />
            </Routes>
        </Router>
    );
};

export default App;